import styled from 'styled-components';
import { COLORS } from '../../models/colors';

export const Message = styled.p`
  font-weight: 700;
  font-size: 30px;
  line-height: 150%;
  margin: 0;
  padding: 0;
  color: ${COLORS.WHITE};
`;
